import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-span-button',
  templateUrl: './span-button.component.html',
  styleUrls: ['./span-button.component.scss']
})
export class SpanButtonComponent {

  @Input() label: string = '';
  @Input() cancel: boolean = false;
  @Input() disabled: boolean = false;

  constructor() { }

}
